import { PSpinner, PText } from '@porsche-design-system/components-react';
import { memo } from 'react';

export const Spinner = memo(() => {
  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center backdrop-blur bg-white bg-opacity-50 z-30">
      <PSpinner
        size={{ base: 'small', l: 'medium' }}
        aria={{ 'aria-label': 'Loading page content' }}
      />
      <PText size="small">Loading Features...</PText>
    </div>
  );
});
